import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics lazily, off the critical path (browser only, not SSR).
// Dynamic import keeps the Analytics SDK out of the initial bundle and defers
// its execution until the browser is idle, so it never blocks first paint.
if (typeof window !== 'undefined') {
  const initAnalytics = () => {
    import('firebase/analytics')
      .then(({ getAnalytics }) => getAnalytics(app))
      .catch(() => { /* analytics is non-critical; ignore load failures */ });
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initAnalytics, { timeout: 5000 });
  } else {
    window.setTimeout(initAnalytics, 3000);
  }
}
// Initialize Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to emulators in development
if (process.env.NODE_ENV === 'development') {
  // Flag to prevent multiple connections
  let emulatorsConnected = false;
  
  if (!emulatorsConnected) {
    try {
      connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
      // console.log('Connected to Auth emulator');
    } catch (error) {
      // console.log('Auth emulator connection failed or already connected:', error.message);
    }

    try {
      connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
      // console.log('Connected to Firestore emulator');
    } catch (error) {
      // console.log('Firestore emulator connection failed or already connected:', error.message);
    }

    try {
      connectStorageEmulator(storage, '127.0.0.1', 9199);
      // console.log('Connected to Storage emulator');
    } catch (error) {
      // console.log('Storage emulator connection failed or already connected:', error.message);
    }

    try {
      connectFunctionsEmulator(functions, '127.0.0.1', 5001);
      // console.log('Connected to Functions emulator');
    } catch (error) {
      // console.log('Functions emulator connection failed or already connected:', error.message);
    }
    
    emulatorsConnected = true;
  }
}

export default app;
